<div class="auth-wrapper">
  <mat-card class="auth-card" appearance="outlined">
    <mat-card-content class="auth-content">
      <h1 class="headline">{{ 'authorizationError.headline' | transloco }}</h1>
      @if (reasonKey) {
        <p class="supporting reason" data-testid="reason">{{ reasonKey | transloco }}</p>
      }
      <p class="supporting">{{ 'authorizationError.body1' | transloco }}</p>
      <p class="supporting">{{ 'authorizationError.body2' | transloco }}</p>
    </mat-card-content>
  </mat-card>
</div>
